export default __webpack_public_path__ + "static/media/img3.162ca33b.png";